export enum CustomNavbarIconTypes {
  CERTIFICATION = 'certification',
  SOC_SIM = 'soc-sim',
  TH_SIM = 'th-sim',
  PATH = 'path',
}
